import { render } from "./ModalOBPassword.vue?vue&type=template&id=a5d72328&scoped=true&ts=true"
import script from "./ModalOBPassword.vue?vue&type=script&lang=ts"
export * from "./ModalOBPassword.vue?vue&type=script&lang=ts"

import "./ModalOBPassword.vue?vue&type=style&index=0&id=a5d72328&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5d72328"]])

export default __exports__